export const GIG_TAGS = [
  "delivery",
  "design",
  "tutoring",
  "cleaning",
  "events",
  "tech",
  "photography",
  "writing",
  "moving",
  "handyman",
  "beauty",
  "fitness",
  "pets",
  "music",
  "other",
] as const;

export type GigTag = (typeof GIG_TAGS)[number];

export const TAG_LABEL: Record<GigTag, string> = {
  delivery: "🛵 Delivery",
  design: "🎨 Design",
  tutoring: "📚 Tutoring",
  cleaning: "🧽 Cleaning",
  events: "🎉 Events",
  tech: "💻 Tech",
  photography: "📷 Photo",
  writing: "✍️ Writing",
  moving: "📦 Moving",
  handyman: "🔧 Handyman",
  beauty: "💅 Beauty",
  fitness: "🏋️ Fitness",
  pets: "🐶 Pets",
  music: "🎧 Music",
  other: "✨ Other",
};
